import { Style } from "./Style";

let defaultStyle;

export class ImageStyle extends Style {
    static get DEFAULT() {
        return defaultStyle || (defaultStyle = new ImageStyle);
    }
    constructor(style = {}, headerStyle = {}) {
        var _a;
        super(style, headerStyle), this.textAlign = (null !== (_a = style.textAlign) && void 0 !== _a ? _a : null == headerStyle ? void 0 : headerStyle.textAlign) || "center";
    }
    clone() {
        return new ImageStyle(this);
    }
}
//# sourceMappingURL=ImageStyle.js.map
